<template>
  <div class="contents">
    <div class="opt">
      <div class="tab">
        <span
          v-permissson="'QB'"
          class="tabItem"
          :class="{ active: active === 10000 }"
          @click="changeType(10000, 'QB')"
        >全部({{ tabTotal || 0 }})</span
        >
        <span
          v-permissson="'WFS'"
          class="tabItem"
          :class="{ active: active === 1 }"
          @click="changeType(1, 'WFS')"
        >未发送({{ tabNumer.find(a => a.type === 0)?.qty || 0 }})</span
        >
        <span
          v-permissson="'YFS'"
          class="tabItem"
          :class="{ active: active === 2 }"
          @click="changeType(2, 'YFS')"
        >已发送({{ tabNumer.find(a => a.type === 1)?.qty || 0 }})</span
        >
        <span
          v-permissson="'QX'"
          class="tabItem"
          :class="{ active: active === 3 }"
          @click="changeType(3, 'QX')"
        >取消({{ tabNumer.find(a => a.type === 2)?.qty || 0 }})</span
        >
      </div>
      <div style="display: flex">
        <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div class="sure" @mousedown="handleConfirm">确定</div>
            </div>
          </el-popover>
          <el-input
            :value="searchVal"
            placeholder="请输入提单号/柜号/参考号搜索"
            class="input-search"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="tableData"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :loading="loading"
        :isPager="true"
        :isEmptyBorder="true"
        @sortChange="sortChange"
        @handlePageChange="handlePageChange"
      >
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-show="computedPermissions('取消')"
                  :v-permissson="computedPermissions('取消')"
                  class="opt-item"
                  @click="handleDelete(row.scope)"
                >取消</el-button
                >
                <el-button
                  v-show="computedPermissions('发送')"
                  :v-permissson="computedPermissions('发送')"
                  class="opt-item"
                  @click="send(row.scope)"
                >发送</el-button
                >
                <el-button
                  v-show="computedPermissions('附件')"
                  :v-permissson="computedPermissions('附件')"
                  class="opt-item"
                  @click="viewFile(row.scope)"
                >附件</el-button
                >
                <el-button
                  v-show="computedPermissions('重发')"
                  :v-permissson="computedPermissions('重发')"
                  class="opt-item"
                  @click="send(row.scope)"
                >重发</el-button
                >
              </div>
            </div>
            <img slot="reference" src="@/assets/images/table/opt.png" />
          </el-popover>
        </template>
        <template slot="etdeta" slot-scope="row">
           <p style="text-align: left;">
            <span class="label">ETD</span>
            <span class="value">{{ row.scope.etd }}</span>
          </p>
          <p style="text-align: left;">
            <span class="label">ATD</span>
            <span class="value">{{ row.scope.atd }}</span>
          </p>
        </template>
        <template slot="etaata" slot-scope="row">
           <p style="text-align: left;">
            <span class="label">ETA</span>
            <span class="value">{{ row.scope.eta }}</span>
          </p>
          <p style="text-align: left;">
            <span class="label">ATA</span>
            <span class="value">{{ row.scope.ata }}</span>
          </p>
        </template>
        <template slot="port" slot-scope="row">
           <p style="text-align: left;">
            <span class="label">始发港</span>
            <span class="value">{{ row.scope.originHarborName }}</span>
          </p>
          <p style="text-align: left;">
            <span class="label">卸货港</span>
            <span class="value">{{ row.scope.dischargeHarbor }}</span>
          </p>
          <p style="text-align: left;">
            <span class="label">目的港</span>
            <span class="value">{{ row.scope.destinationHarborName }}</span>
          </p>
          <p style="text-align: left;">
            <span class="label">船名/航次</span>
            <span class="value">{{ row.scope.vesselName }} / {{ row.scope.voyageNo }}</span>
          </p>
        </template>
      </BaseTable>
    </div>
    <SendEmailDialog :rowData="rowData" :dialogVisible="dialogVisible" @cancel="dialogVisible = false" @ok="dialogVisible = false; getList(pager)"></SendEmailDialog>
    <ClearenceFileDialog :rowData="rowData" :dialogVisible="dialogVisible1" @cancel="dialogVisible1 = false"></ClearenceFileDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseMutiInput = () => import('@/components/base/BaseMutiInput')
import SendEmailDialog from './components/SendEmailDialog'
import ClearenceFileDialog from './components/ClearenceFileDialog'

import { permissions } from '@/utils/common'
import { getForecastPages, cancelForecast } from '@/api/bill'
import { myMixins } from '@/mixins'
export default {
  name: 'Product',
  components: {
    BaseTable,
    BaseMutiInput,
    SendEmailDialog,
    ClearenceFileDialog
  },
  mixins: [myMixins],
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true,
            fixed: 'left'
          },
          {
            filed: 'companyName',
            label: '客户',
            width: '180'
          },
          {
            filed: 'mblNo',
            label: '提单号',
            width: '180'
          },
          {
            filed: 'containerNumber',
            label: '柜号',
            width: '180'
          },
          {
            filed: 'containerType',
            label: '柜型',
            width: '120'
          },
          {
            filed: 'etdeta',
            label: '开船日期',
            width: '240',
            isCustom: true
          },
          {
            filed: 'dischargeHarborDate',
            label: '到卸货港日期',
            width: '240'
          },
          {
            filed: 'port',
            label: '港口信息',
            width: '250px',
            isCustom: true
          },
          {
            filed: 'qty',
            label: '提单件数',
            width: '150'
          },
          {
            filed: 'weightKgs',
            label: '重量',
            width: '150'
          },
          {
            filed: 'remark',
            label: '备注',
            width: '150'
          },
          {
            filed: 'forecastDate',
            label: '预报创建日期',
            width: '150'
          },
          {
            filed: 'sendSupplierOn',
            label: '已发美国日期',
            width: '150'
          },
          {
            filed: 'clearenceSupplier',
            label: '清关行',
            width: '150'
          },
          {
            filed: 'operatorHanders',
            label: '客服负责人',
            width: '150'
          },
          {
            filed: 'customerHanders',
            label: '操作负责人',
            width: '150'
          },
          {
            filed: 'totalPrice',
            label: '申报货值',
            width: '150'
          },
          {
            filed: 'forecastTaxes',
            label: '清关税金',
            width: '150'
          },
          {
            filed: 'currentTaxes',
            label: '税金',
            width: '280'
          }
        ],
        columns: [],
        total: 0
      },
      loading: false,
      filterList: {},
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      sortable: {
        sortField: undefined,
        sortBy: undefined
      },
      referenceNumber: '',
      searchVal: '',
      dialogVisible: false,
      dialogVisible1: false,
      height: 0,
      rowData: {},
      active: 10000,
      tabNumer: [],
      tabTotal: 0,
      activeCode: ''
    }
  },
  computed: {
    computedPermissions() {
      return function(key) {
        const menuList = this.$store.getters.initRouter
        const menu = permissions(this.$route.meta.code, menuList)
        const presentTab = menu.children.find(
          (a) => a.code === this.activeCode
        )
        const code = presentTab?.children?.find((a) => a.nameCH === key)?.code
        return code || ''
      }
    }
  },
  created() {
    const menuList = this.$store.getters.initRouter
    const menu = permissions(this.$route.meta.code, menuList)
    const codeList = ['QB', 'WFS', 'YFS', 'QX']
    const childrenCode = menu.children.map((a) => a.code)
    this.active = codeList.findIndex((a) => childrenCode.includes(a)) === 0 ? 10000 : (codeList.findIndex((a) => childrenCode.includes(a)) === 0) - 1
    this.activeCode = menu.children[0].code
    this.getList(this.pager)
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
  },
  methods: {
    changeType(type, code) {
      this.active = type
      this.activeCode = code
      this.pager = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.getList(this.pager)
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.sortable,
            number: this.searchVal ? this.searchVal.split(';') : undefined,
            status: this.active === 10000 ? undefined : this.active - 1
          }
        }
        const res = await getForecastPages(params)
        if (res.success) {
          this.loading = false
          this.tableData.columns = res.data.list.map((item) => {
            return {
              ...item,
              visible: false
            }
          })
          this.tabNumer = res.data.tabNumer
          this.tabTotal = res.data.total
        } else {
          this.loading = false
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        iconClass: 'warning',
        showClose: false,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        center: true
      }).then(() => {
        cancelForecast({
          id: row.id
        }).then((res) => {
          if (res.success) {
            this.$message.success('取消成功')
            this.initList()
          } else {
            this.$message.error(res.errorMessage)
          }
        })
      })
    },
    sortChange(params) {
      console.log('params', params)
      this.sortable.sortField = params.prop || undefined
      this.sortable.sortBy =
        params.order === undefined ? undefined : params.order
      this.getList()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.searchVal = this.referenceNumber.join(';')
        }
        this.$refs.popover.doClose()
        this.initList()
      }, 0)
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    ok() {
      this.cancel()
      this.initList()
    },
    initList() {
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.getList(params)
    },
    handlePageChange(pager) {
      this.pager = {
        ...pager
      }
      this.getList(pager)
    },
    send(row) {
        this.rowData = row
        this.dialogVisible = true
    },
    viewFile(row) {
        this.rowData = row
        this.dialogVisible1 = true
    }
  }
}
</script>

<style lang="less" scoped>
.contents {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
}
.opt {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  .tabItem {
    padding: 20px;
    width: 42px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    cursor: pointer;
  }
  .active {
    color: rgb(18, 88, 188);
  }
  .search {
    position: relative;
    display: flex;
    width: 200px;
    margin-right: 8px;
    .searchPop {
      /deep/ .el-popover {
        z-index: 9999;
        right: 0;
      }
      .close {
        position: absolute;
        top: 6px;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      }
    }
    .input-search {
      width: 166px;
      height: 30px !important;
      /deep/ .el-input__inner {
        height: 30px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-search {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border: 1px solid #dbe4f2;
      border-left: 0;
      border-radius: 0 4px 4px 0;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
}
.add {
  width: 84px;
  height: 30px;
  background: rgb(18, 88, 188);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
  margin-left: 16px;
  svg {
    font-size: 20px;
  }
}
.data {
  width: 100%;
  height: calc(100% - 54px);
  z-index: 1;
  & .fTable {
    border-top: 1px solid #ebeef5;
    box-sizing: border-box;
  }
  &:deep(.el-button) + .el-button {
    margin-left: 20px;
  }
  &:deep(.el-button--text) {
    padding: 0;
  }
  p + p {
    margin-top: 2px;
  }
  .label {
    width: 60px;
    height: 18px;
    display: inline-block;
    line-height: 18px;
    text-align: center;
    background: #768292;
    border-radius: 4px 4px 4px 4px;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
  }
  .value {
    margin-left: 8px;
    font-family: Microsoft YaHei UI, Microsoft YaHei UI;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}
</style>
